module.exports = __webpack_public_path__ + "img/middleleft2.fb641c9a.png";